import intro_1_mobile from "@/assets/images/intro_1_mobile.png";
import intro_2_mobile from "@/assets/images/intro_2_mobile.png";
import intro_3_mobile from "@/assets/images/intro_3_mobile.png";
import intro_4_mobile from "@/assets/images/intro_4_mobile.png";
import intro_1_desktop from "@/assets/images/intro_1_desktop.png";
import intro_2_desktop from "@/assets/images/intro_2_desktop.png";
import intro_3_desktop from "@/assets/images/intro_3_desktop.png";
import intro_4_desktop from "@/assets/images/intro_4_desktop.png";
import WelcomeVideoThumb from "@/assets/images/intro_video_thumb.png";
import { OnboardingProgressData } from "@/index-db/db.types";

export const INTRO_CAROUSEL_DATA = [
  {
    title: "Learn about Menopause Stages",
    description:
      "Use our CanesMeno® Guide to learn more about your menopause stage and explore how to equip yourself to navigate this lifestage.",
    image_mobile: intro_1_mobile,
    image_desktop: intro_1_desktop,
  },
  {
    title: "Track your Signs",
    description:
      "Easily track and monitor your menopause experience, such as hot flushes and night sweats, mood swings or sleep disturbances.",
    image_mobile: intro_2_mobile,
    image_desktop: intro_2_desktop,
  },
  {
    title: "Gain Insights",
    description:
      "Gain personal insights into your experiences over time, identify patterns, and understand how changes related to menopause impact your life.",
    image_mobile: intro_3_mobile,
    image_desktop: intro_3_desktop,
  },
  {
    title: "Holistic Coaching",
    description:
      "Access renowned feminine empowerment expert and certified professional coach Karen Heras-Kelly's 'M-Powerment' Programme to support you through the changes of menopause.",
    image_mobile: intro_4_mobile,
    image_desktop: intro_4_desktop,
  },
];

export const WELCOME_VIDEO_DATA = {
  url: "https://player.vimeo.com/video/1145518542",
  thumbnailUrl: WelcomeVideoThumb,
  title: "",
  duration: "",
};

export const ONBOARDING_NAV_PAGES: {
  [key: string]: OnboardingProgressData["currentPage"];
} = {
  WELCOME: "welcome",
  INTRO: "intro",
  TAPTOSTART: "tap-to-start",
};
